import { WidgetViewModel } from '../../viewModel/viewModel';

type OnDialogCloseOptions = {
  doNotReturnFocus?: boolean;
};

export type OnDialogCloseAction = (options?: OnDialogCloseOptions) => void;

export const createOnDialogCloseAction = ({
  widgetViewModel,
  setProps,
}: {
  widgetViewModel: WidgetViewModel;
  setProps: Function;
}): OnDialogCloseAction => {
  return (options) => {
    if (options?.doNotReturnFocus) {
      widgetViewModel.dialogViewModel.returnFocusOnDeactivate = false;
      setProps({ widgetViewModel });
    }

    widgetViewModel.dialogViewModel.isOpen = false;
    setProps({ widgetViewModel });
  };
};
